<template>

  <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 10px;">
    <v-select
        v-model="cittaSelezionata"
        :options="citta"
        label="comune"
        @input="impostaProvincia"
        placeholder="Seleziona una città"
    ></v-select>


    <input
        class="form-control"
        type="text"
        disabled
        v-model="provinciaCorrispondente"
        placeholder="Provincia corrispondente"
    />
  </div>





</template>


<script>


export default {
  name: 'City',
  data() {
    return {
      citta: [],
      cittaSelezionata: '',
      provinciaCorrispondente: ''
    };
  },
  mounted() {
    axios.get('/api/v2/catasto/cities')
        .then(response => {
          this.citta = response.data;
        })
        .catch(error => {
          console.log(error);
        });
  },
  methods: {
    impostaProvincia() {
      if (this.cittaSelezionata) {
        this.provinciaCorrispondente = this.cittaSelezionata.SiglaProv;
        this.$emit('update:comune', this.cittaSelezionata.comune);
        this.$emit('update:provincia', this.provinciaCorrispondente);
      } else {
        this.provinciaCorrispondente = '';
      }
    }
  }
};
</script>
